import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CheckSquare, Sparkles, LineChart, Settings as SettingsIcon, Eye } from 'lucide-react';
export function Sidebar() {
  const topNav = [{
    name: 'Guide',
    path: '/',
    icon: Home
  }, {
    name: 'Progress',
    path: '/log',
    icon: CheckSquare
  }, {
    name: 'Self-Reflection',
    path: '/reflection',
    icon: Sparkles
  }, {
    name: 'GPS Settings',
    path: '/settings',
    icon: SettingsIcon
  }];
  const bottomNav = [{
    name: 'My Mirror (Sample)',
    path: '/mirror',
    icon: LineChart
  }, {
    name: 'Guide (Sample)',
    path: '/sample',
    icon: Eye
  }];
  const linkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-indigo-50 text-indigo-600' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`;
  return <div className="w-64 h-screen fixed left-0 top-0 bg-white border-r border-gray-200 flex flex-col justify-between" data-id="element-34">
      <div data-id="element-35">
        <div className="p-6" data-id="element-36">
          <h1 className="text-xl font-bold text-gray-900 tracking-tight" data-id="element-37">
            GPS Journal
          </h1>
        </div>

        <nav className="px-4 space-y-1" data-id="element-38">
          {topNav.map(item => {
          const Icon = item.icon;
          return <NavLink key={item.name} to={item.path} className={linkClass} data-id="element-39">
                <Icon className="w-5 h-5" data-id="element-40" />
                {item.name}
              </NavLink>;
        })}
        </nav>
      </div>

      <nav className="px-4 pb-6 space-y-1" data-id="element-41">
        {bottomNav.map(item => {
        const Icon = item.icon;
        return <NavLink key={item.name} to={item.path} className={linkClass} data-id="element-42">
              <Icon className="w-5 h-5" data-id="element-43" />
              {item.name}
            </NavLink>;
      })}
      </nav>
    </div>;
}